import React from "react";

const Location = () => {
  return (
    <div className="location">
      <h1 className="locationH1">Beschikbaar in Heel Zuid-Holland</h1>
      <p className="locationP">
        Met ons servicegebied dat zich uitstrekt over heel Zuid-Holland, bieden
        wij onze schoonmaakdiensten aan klanten in Den Haag, Rotterdam, Leiden,
        Delft en alle andere steden en regio's in Zuid-Holland.
      </p>
      <p className="locationP">
        Of u nu een woning, bedrijfspand of speciale locatie heeft, onze
        professionele schoonmaakteams staan klaar om uw ruimtes te laten
        stralen, waar u zich ook bevindt in Zuid-Holland.
      </p>
    </div>
  );
};

export default Location;
